import { render, staticRenderFns } from "./floating-buttons.vue?vue&type=template&id=652a1ec1&scoped=true"
import script from "./floating-buttons.vue?vue&type=script&lang=js"
export * from "./floating-buttons.vue?vue&type=script&lang=js"
import style0 from "./floating-buttons.vue?vue&type=style&index=0&id=652a1ec1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652a1ec1",
  null
  
)

export default component.exports